export default __webpack_public_path__ + "images/elephant_ganjarelex-9044ff5a797748f9e5a33aefcb6ef876.jpg";